import SupplierButton from './SupplierButton';

export default SupplierButton;
